import * as Common from "../Common/modules";
import * as Models from "../Models";

export interface IPricingApiClient {
  getActiveUtilitiesAvailableToAssignToCustomer(territoryId: number, partnerSystemNumber: string, leadNumber: string): ng.IPromise<Models.CostCalculation.Utility.IUtility[]>;
  getRegionAssignedToCustomer(identifier: string): ng.IPromise<Models.CostCalculation.Region.IRegion>;
  getRegionPricing(regionPricingId: number): ng.IPromise<Models.CostCalculation.RegionPricing.IRegionPricing>;
}

export class PricingApiClient implements IPricingApiClient {
  public static $inject = ["igs.apiClientService"];

  public prefix: string;

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    this.prefix = "Pricing";
  }

  public getActiveUtilitiesAvailableToAssignToCustomer = (territoryId: number, partnerSystemNumber: string, leadNumber: string): ng.IPromise<Models.CostCalculation.Utility.IUtility[]> => {
    var url = `${this.prefix}/GetActiveUtilitiesAvailableToAssignToCustomer/${territoryId}?partnerSystemNumber=${partnerSystemNumber || ''}&leadNumber=${leadNumber || ''}`;

    return this.igsApiClientService.get(url);
  }

  public getRegionAssignedToCustomer = (identifier: string): ng.IPromise<Models.CostCalculation.Region.IRegion> => {
    const url = `${this.prefix}/GetRegionAssignedToCustomer/${identifier}`;
    return this.igsApiClientService.get(url);
  }

  public getRegionPricing = (regionPricingId: number): ng.IPromise<Models.CostCalculation.RegionPricing.IRegionPricing> => {
    const url = `${this.prefix}/RegionPricing/${regionPricingId}`;
    return this.igsApiClientService.get(url);
  }
}
